// extracted by mini-css-extract-plugin
module.exports = {"button":"confirm-phone-number_button__2ngt6","disclaimers":"confirm-phone-number_disclaimers__3KT7X"};